import { useState, useContext, useEffect } from "react";
import isEmpty from "lodash/isEmpty";
import { db } from "../../firebase";
import { AuthContext } from "../../contexts/AuthContext";
import constants from "../../utils/constants";

const { DB_NAME } = constants;

const useFetchIsReceiverBlockedYou = (receiverUid) => {
  const { currentUser } = useContext(AuthContext);
  const uid = currentUser?.uid;

  const [isLoading, setIsLoading] = useState(false);
  const [isGotResponse, setIsGotResponse] = useState(false);
  const [isReceiverBlockedYou, setIsReceiverBlockedYou] = useState(false);

  const fetchIsReceiverBlockedForChat = async () => {
    setIsLoading(true);
    await db
      .collection(DB_NAME.BLOCKED_USERS)
      .doc(receiverUid)
      .get()
      .then((doc) => {
        if (!isEmpty(doc.data())) {
          let data = doc.data();
          const isReceiverBlockedRes = data && data.blockedUser[uid];

          if (isReceiverBlockedRes) {
            setIsReceiverBlockedYou(isReceiverBlockedRes);
            setIsGotResponse(true);
          }
        }
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (uid) {
      fetchIsReceiverBlockedForChat();
    }
  }, [receiverUid]);

  return { isLoading, isReceiverBlockedYou, isGotResponse };
};

export default useFetchIsReceiverBlockedYou;
